// Distinguishes which surface opened the jurisdiction picker, so a completed save can be
// attributed back to the nudge that drove it instead of being indistinguishable from a direct edit.
export enum MatterJurisdictionEntrySource {
  AllMattersTooltip = 'all_matters_tooltip',
  MatterDetailCta = 'matter_detail_cta',
  Direct = 'direct',
}
